// web/src/screens/SitePaused.tsx — where a switched-off site's visitors land (portal spec 25). Public: no login, no AppShell.
// Cloudflare's site-off redirect sends https://<client domain>/… here as /paused?r=payment (plan paused) or ?r=closed (plan ended).
import { useSearchParams } from 'react-router-dom';

export function SitePaused() {
  const [p] = useSearchParams();
  const closed = p.get('r') === 'closed';
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center bg-bg px-4 py-16 text-center">
      <div className="mx-auto flex w-full max-w-md flex-col gap-3">
        <h1 className="font-head text-2xl text-ink">{closed ? 'This website has moved on' : 'This website is taking a short break'}</h1>
        <p className="text-muted">{closed ? 'It is no longer hosted by yourproject.ai.' : 'It will be back soon.'}</p>
        {!closed && (
          <p className="text-sm text-muted">
            Are you the owner?{' '}
            <a className="inline-flex min-h-11 items-center text-info underline" href="/billing">Sign in to update your billing</a>.
          </p>
        )}
      </div>
    </main>
  );
}
